import { InjectionToken } from '@angular/core';
import { IAlertService } from './alert-service';

export const ALERT_SERVICE = new InjectionToken<IAlertService>('ALERT_SERVICE');
